import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import { Icon } from '../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BadgeTheme;

(function (BadgeTheme) {
  BadgeTheme["EMERALD"] = "emerald";
  BadgeTheme["ROSE"] = "rose";
  BadgeTheme["AMBER"] = "amber";
  BadgeTheme["PURPLE"] = "purple";
  BadgeTheme["BLUE"] = "blue";
})(BadgeTheme || (BadgeTheme = {}));

/**
 * Primary UI component for user interaction
 */
export var Badge = function Badge(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      theme = _ref.theme,
      size = _ref.size,
      iconPosition = _ref.iconPosition,
      otherProps = _ref.otherProps;
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: classNames('flex rounded-full py-0.5 px-2.5 w-max', {
      // THEME
      'text-green-700 bg-green-100': theme === BadgeTheme.EMERALD,
      'text-rose-800 bg-rose-100': theme === BadgeTheme.ROSE,
      'text-yellow-700 bg-yellow-100': theme === BadgeTheme.AMBER,
      'text-purple-800 bg-purple-200': theme === BadgeTheme.PURPLE,
      'text-blue-800 bg-blue-200': theme === BadgeTheme.BLUE,
      // ICON POSITION
      'flex-row': iconPosition === 'left',
      'flex-row-reverse': iconPosition === 'right',
      // SIZE
      'text-base': size === 'lg',
      'text-sm': size === 'md',
      'text-xs': size === 'sm'
    })
  }, otherProps), {}, {
    children: [iconPosition !== 'none' ? /*#__PURE__*/_jsx("span", {
      className: classNames({
        'mr-2': iconPosition === 'left',
        'ml-2': iconPosition === 'right'
      }),
      children: /*#__PURE__*/_jsx(Icon, _objectSpread({}, icon))
    }) : null, label]
  }));
};
Badge.defaultProps = {
  theme: BadgeTheme.EMERALD,
  size: 'md',
  iconPosition: 'none'
};